import { IConsistencyCheckVisibility } from '../interfaces/consistency-check-visibility.interface';
import { IDisplayOptionsVisibility } from '../interfaces/display-options-visibility.interface';
import { SignatureOptionsGermanVisibility } from './signature-options.german-visibility.type';
import { SignatureOptionsSwissVisibility } from './signature-options.swiss-visibility.type';
import { StyleOptionsGermanVisibility } from './style-options-german-visibility.type';
import { StyleOptionsSwissVisibility } from './style-options-swiss-visibility.type';

export type PrintOptionsVisibility = {
    consistencyCheck: IConsistencyCheckVisibility;
    styleOptions: StyleOptionsGermanVisibility | StyleOptionsSwissVisibility;
    displayOptions: IDisplayOptionsVisibility;
    signatureOptions: SignatureOptionsGermanVisibility | SignatureOptionsSwissVisibility;
};
